import Button from '@components/Button';
import Row from '@components/Row';
import { InquiryResponse } from '@models/inquiry';
import { useFlow } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

interface Props {
    inquiry: InquiryResponse;
}

/** 답변 완료: 문의 종료·추가 문의 / 답변 대기: 비활성 안내 버튼 (종료된 문의는 푸터 자체를 숨긴다) */
function InquiryFooter({ inquiry }:Props) {
    const { t } = useTranslation('inquiry');
    const { push } = useFlow();
    const { status } = inquiry;
    if (status !== 'ANSWERED') {
        return (
            <Button fullWidth disabled>
                {t('log.waiting')}
            </Button>
        );
    }
    return (
        <Row fullWidth spacing={2}>
            <Button fullWidth
                variant='tone'
                onClick={() => push('CloseInquiryModal', { inquiryId: inquiry.id })} >
                {t('log.close')}
            </Button>
            <Button fullWidth
                onClick={() => push('InquiryCommentBottomSheet', { inquiryId: inquiry.id })} >
                {t('log.addInquiry')}
            </Button>
        </Row>
    );
}

export default InquiryFooter;
